export const UPDATE_MERCHANT_DASHBOARD_MUTATION = gql`
    mutation updateMerchantDashboard($id: Int!, $input: UpdateMerchantDashboardInput!) {
        updateMerchantDashboard(id: $id, input: $input) {
            id
            status
        }
    }
`;

export const PROCESS_MERCHANT_REQUEST_BUILD = gql`
    mutation processRequestBuild($input: ProcessRequestBuildInput!) {
        processRequestBuild(input: $input) {
            id
            application {
                id
                status
            }
            status
            mid
            terminalId
        }
    }
`;
